import icon from '~/assets/public/xero-icon.png';
import { Tooltip } from '~/components';
import { useIntegrations } from '~/contexts';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  cursor: pointer;
`;

const Image = styled.img`
  width: 1rem;
  height: 1rem;
`;

export default function XeroInvoiceIndicator({ message = 'This invoice is in Xero.', xeroInvoiceId }) {
  const integrations = useIntegrations();
  if (!integrations.xero) return null;

  const handleClick = (event) => {
    event.stopPropagation();

    if (xeroInvoiceId) {
      const invoiceURL = integrations.xero.orgCode
        ? `https://go.xero.com/organisationlogin/default.aspx?shortcode=${integrations.xero.orgCode}&redirecturl=/AccountsReceivable/View.aspx?InvoiceID=${xeroInvoiceId}`
        : `https://go.xero.com/app/invoicing/view/${xeroInvoiceId}`;
      return window.open(invoiceURL, '_blank');
    }
  };

  return (
    <Wrapper onClick={handleClick}>
      <Tooltip message={message}>
        <Image src={icon} />
      </Tooltip>
    </Wrapper>
  );
}
